export default {
  list: []
}



// WEBPACK FOOTER //
// ./src/features/assignment_request/store/state.js